import type { DropdownSelectItem } from '@/components/lemmala-design-system/dropdown/dropdown-select.types'

import type { AssigneePerson } from './types'

export const idsKey = (ids: string[]) => ids.join('\0')

export const idsFromKey = (key: string) => (key === '' ? [] : key.split('\0'))

/** Stable content key so parent `|| []` / new array identity does not thrash memos. */
export const assigneePeopleContentKey = (people: readonly AssigneePerson[]) =>
  people.map((user) => `${user.id}\0${user.name}\0${user.email}`).join('\u0001')

// ListUsers catalog plus current assignees missing from it (e.g. left the org).
export const mergeAssigneePeople = (
  catalog: readonly AssigneePerson[],
  selected: readonly AssigneePerson[],
): AssigneePerson[] => {
  const byId = new Map<string, AssigneePerson>()
  for (const user of catalog) {
    byId.set(user.id, user)
  }
  for (const user of selected) {
    if (!byId.has(user.id)) {
      byId.set(user.id, user)
    }
  }
  return [...byId.values()]
}

export const sortAssigneeItems = (
  items: DropdownSelectItem[],
  selectedUserIds: string[],
  currentUserId?: string,
): DropdownSelectItem[] => {
  const selectedIds = new Set(selectedUserIds)

  // Assigned → logged-in user (if not assigned) → rest.
  const rank = (id: string) => {
    if (selectedIds.has(id)) return 0
    if (currentUserId && id === currentUserId) return 1
    return 2
  }

  return [...items].sort((a, b) => {
    const rankDiff = rank(a.id) - rank(b.id)
    if (rankDiff !== 0) return rankDiff
    return a.label.localeCompare(b.label)
  })
}
